import { Typography } from '@mui/material';
import getAxios from 'getAxios';
import React, { memo } from 'react';
import { Confirm, Link, useNotify, useRecordContext, useRefresh } from 'react-admin';

const axios = getAxios();

const getIsUsing12hRates = (record) => {
  const isTen99Plan = record?.primary_billing_group?.plan === 'standard';

  const baseSettings = isTen99Plan
    ? record?.location_rate_settings?.settings?.ten99
    : record?.location_rate_settings?.settings?.w2?.local;

  return baseSettings?.use_blended_rate || false;
};

const ChangeRateStructureConfirmDialog = ({ isOpen, onClose }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const lrs = record?.location_rate_settings;
  const hasExistingLRS = !!lrs.id;

  const isUsing12hRates = getIsUsing12hRates(record);

  const closeAndRefresh = () => {
    onClose();
    refresh();
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`v3/admin/locations/${record.id}/set_rate_structure`);
      notify(
        response?.data?.message ??
          `Location Rate Setting record ${hasExistingLRS ? 'updated' : 'created'}`,
        { type: 'success' },
      );
      closeAndRefresh();
    } catch (error: any) {
      notify(error?.message ?? 'Error', { type: 'error' });
    } finally {
      closeAndRefresh();
    }
  };

  return (
    <Confirm
      isOpen={isOpen}
      fullWidth
      title="This change requires Facility acknowledgement"
      content={
        <div>
          <Typography component="p" variant="body2">
            This request will update the rate structure to{' '}
            <strong>{isUsing12hRates ? '8' : '12'} hours</strong>. This will{' '}
            <strong>{hasExistingLRS ? 'update an existing' : 'create a new'}</strong> Location Rate
            Settings record,{' '}
            {hasExistingLRS && (
              <Link to={`/LocationRateSetting/${lrs.id}/show`} target="_blank">
                ({lrs.id}){' '}
              </Link>
            )}
            and the Facility will be required to review and accept this new rate structure before
            they can proceed.
          </Typography>
          <Typography component="p" variant="body2" mt={2}>
            Until they do, they will be <strong>unable to post</strong> new jobs or assignments.
          </Typography>
        </div>
      }
      onConfirm={handleSubmit}
      onClose={onClose}
      confirm={`${hasExistingLRS ? 'Update' : 'Create'} and Present Acknowledgment in Facility App`}
      CancelIcon={() => null}
      ConfirmIcon={() => null}
    />
  );
};

export default memo(ChangeRateStructureConfirmDialog);
